import React, { useMemo } from 'react';
import { Select } from 'antd';

const FieldsSelect = ({
  onSelect,
  style = {},
  fields,
  value,
  allowClear = true,
  mode,
  disabled = false,
  selectClassName = '',
}) => {
  const options = useMemo(
    () =>
      fields
        .filter((el) => el?.fields?.length)
        .map((group) => ({
          label: group.title,
          options: group.fields.map((f) => ({
            label: f.name,
            value: f.value,
          })),
        })),
    [fields]
  );

  return (
    <Select
      showSearch
      placeholder="Select a field"
      optionFilterProp="label"
      filterOption={(input, option) => {
        // option может быть как объект с options (см. структуру выше с useMemo), когда это раздел с
        // набором входящих вариантов для выбора, так и вариант для выбора с label и value.
        if ('options' in option) {
          return false;
        }

        return option.label.toLowerCase().includes(input.toLowerCase());
      }}
      style={style}
      dropdownMatchSelectWidth
      dropdownStyle={{ width: 'auto' }}
      value={value || undefined}
      className={`ant-select-border-bottom ${selectClassName}`}
      allowClear={allowClear}
      onChange={onSelect}
      mode={mode || 'default'}
      disabled={disabled}
      getPopupContainer={(triggerNode) => triggerNode}
      virtual={false}
      options={options}
    />
  );
};

export default FieldsSelect;
